export default {
  superUserWorkspaces(state) {
    return state.superUserWorkspaces;
  },
  superUserWorkspaceActiveSources(state) {
    return state.superUserWorkspaceActiveSources;
  },
  superUserWorkspaceActiveSourcesForSelect(state) {
    return state.superUserWorkspaceActiveSources.map((source) => ({
      id: source.value,
      text: source.name,
    }));
  },
  superUserWorkspaceOwners(state) {
    return state.superUserWorkspaceOwners;
  },
  superUserWorkspaceOwnersForSelect(state) {
    return state.superUserWorkspaceOwners.map((owner) => ({
      id: owner.value,
      text: owner.externalKey
        ? owner.externalKey + "-" + owner.name
        : owner.name,
    }));
  },
  superUserWorkspaceDetail(state) {
    return state.superUserWorkspaceDetail;
  },
};
